﻿const completedInvestments = document.querySelector('.completed-investments');
const millionsInvested = document.querySelector('.millions-invested');
const activeInvestments = document.querySelector('.active-investments');

const wantToInvestButton = document.getElementById('want-to-invest-button');
const suscribeFormHome = document.getElementById('form-suscribe-home');
const suscribeEmailHome = document.getElementById('suscribe-email-home');

const startCountValue = 0;
const completedInvestmentsValue = 1000;
const millionsInvestedValue = 50;
const activeInvestmentsValue = 20;
const counterAnimationDuration = 1500;

var countersAnimated = false;
var tabButtons = [];
var tabImages = [];

window.addEventListener('load', () => {
    for (var i = 1; i <= 6; i++) {
        tabButtons.push(document.getElementById('tab-' + i));
        tabImages.push(document.getElementById('tab-img-' + i));
    }

    tabButtons.forEach((tabButton) => {
        tabButton.addEventListener('click', (e) => {
            let elementId = e.currentTarget.id;
            let img = document.getElementById('tab-img-' + elementId.charAt(elementId.length - 1));
            document.querySelectorAll('.tab-img').forEach((tabImage) => {
                tabImage.classList.replace('opacity-100', 'opacity-0');
            });
            img.classList.replace('opacity-0', 'opacity-100');
        });
    });

    setImagesContainerHeight();
    setTabPanelHeight();
    //animateText();

    wantToInvestButton.addEventListener('click', () => {
        sendinblue.track('click_quiero_invertir');
    });

    suscribeFormHome.addEventListener('submit', (event) => {
        if (!suscribeEmailHome.validity.valid) {
            event.preventDefault();
        } else {
            let properties = {
                'email': suscribeEmailHome.value,
                'RECIBE_NOTICIAS': true
            };
            sendinblue.identify(suscribeEmailHome.value, properties);

            properties = {
                'email': suscribeEmailHome.value,
                'form': 'home_form',
                'RECIBE_NOTICIAS': true
            };
            sendinblue.track('suscripcion_newsletter', properties);
        }
    });
});

window.addEventListener('scroll', () => {
    if (window.scrollY > 200) {
        if (countersAnimated === false) {
            animateValue(completedInvestments, startCountValue, completedInvestmentsValue, counterAnimationDuration);
            animateValue(millionsInvested, startCountValue, millionsInvestedValue, counterAnimationDuration);
            animateValue(activeInvestments, startCountValue, activeInvestmentsValue, counterAnimationDuration);
            countersAnimated = true;
        }
    }
});

window.addEventListener('resize', function (event) {
    setImagesContainerHeight();
    setTabPanelHeight();
});

const setImagesContainerHeight = () => {
    let height = document.querySelector('.tab-img').clientHeight;
    document.getElementById('tab-img-container').style.height = height + 'px';
}

const setTabPanelHeight = () => {
    let height = 0;
    document.querySelectorAll('.tab-pane').forEach((pane) => {
        height = pane.clientHeight > height ? pane.clientHeight : height;
    });
    document.getElementById('numberTabsContent').style.height = height + 'px';
}

const animateValue = (obj, start, end, duration) => {
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Math.floor(progress * (end - start) + start).toLocaleString('en-US');
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

const animateText = () => {
    let part;
    let i = 0;
    let offset = 0;
    let len = features.length;
    let forwards = true;
    let skip_count = 0;
    let skip_delay = 400;
    let speed = 10;

    intervalID = setInterval(function () {
        if (forwards) {
            if (offset >= features[i].length) {
                ++skip_count;
                if (skip_count == skip_delay) {
                    forwards = false;
                    skip_count = 0;
                }
            }
        }
        else {
            if (offset == 0) {
                forwards = true;
                i++;
                offset = 0;
                if (i >= len) {
                    i = 0;
                }
            }
        }
        part = features[i].substr(0, offset);
        if (skip_count == 0) {
            if (forwards) {
                offset++;
            }
            else {
                offset--;
            }
        }
        document.querySelector('.features').textContent = part;
    }, speed);
};
